var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6202_32944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.280273C3.2879 0.280273 0.279297 3.28887 0.279297 7.00027C0.279205 7.88287 0.452978 8.75685 0.790693 9.57228C1.12841 10.3877 1.62345 11.1286 2.24754 11.7527C2.87163 12.3768 3.61255 12.8719 4.42799 13.2096C5.24342 13.5473 6.1174 13.7211 7 13.721C10.7107 13.721 13.72 10.7124 13.72 7.00027C13.72 3.28887 10.7107 0.280273 7 0.280273ZM7.6272 2.70647C8.2824 2.70647 8.4749 3.08657 8.4749 3.52127C8.4749 4.06377 8.0409 4.56567 7.2996 4.56567C6.6794 4.56567 6.384 4.25417 6.4022 3.73827C6.4022 3.30357 6.7655 2.70647 7.6272 2.70647ZM5.9486 11.0253C5.5006 11.0253 5.1737 10.753 5.4866 9.55947L5.9997 7.44197C6.0886 7.10317 6.1033 6.96737 5.9997 6.96737C5.866 6.96737 5.2843 7.20117 4.9413 7.43217L4.718 7.06607C5.8065 6.15677 7.0581 5.62337 7.5936 5.62337C8.0416 5.62337 8.1158 6.15257 7.8925 6.96737L7.3045 9.19337C7.2002 9.58677 7.245 9.72257 7.3493 9.72257C7.4837 9.72257 7.9233 9.56017 8.3559 9.21927L8.6093 9.55947C7.5502 10.6179 6.3959 11.0253 5.9486 11.0253Z",
    fill: "#80CBC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6202_32944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.fa1737ac1aa87d42bd1b07222dbd496d.svg";
export { ForwardRef as ReactComponent };